module.exports = __webpack_public_path__ + "static/media/btn_exit.42a16fd8.svg";